<script setup lang="ts">
import { useGlobalCurrencyStore } from '@apps/main/new-desktop/core/stores';

import { AppButton } from '@libs/ui';
// import { formatWithCurrency } from '@libs/utils';

import { useActivityDetailsTicketsStore } from '../stores/activityDetailsTicketsStore';

interface ActivityDetailsFooterEmits {
  (event: 'close'): void;
  (event: 'scroll-to-ticket'): void;
}
const emit = defineEmits<ActivityDetailsFooterEmits>();

const activityDetailsTicketsStore = useActivityDetailsTicketsStore();
const globalCurrencyStore = useGlobalCurrencyStore();

function handleSelect(): void {
  if (activityDetailsTicketsStore.shouldScrollToTicket) {
    emit('scroll-to-ticket');
    return;
  }
  activityDetailsTicketsStore.selectTicket();
  emit('close');
}
</script>

<template>
  <footer class="activity-details-footer">
    <div class="payment-summary">
      <div
        v-if="
          activityDetailsTicketsStore.selectedActivityTotalPrice &&
          activityDetailsTicketsStore.selectedActivityTotalPrice.amount > 0
        "
        class="total-price"
      >
        <span class="total-price--header">{{ $t('planner.total') }}</span>
        <span class="total-price--price">
          {{
            globalCurrencyStore.formatMoney(
              activityDetailsTicketsStore.selectedActivityTotalPrice.amount,
              activityDetailsTicketsStore.selectedActivityTotalPrice.currency
            )
          }}
        </span>
      </div>
    </div>
    <AppButton
      class="select-activities-button"
      state="enabled"
      size="medium"
      type="important"
      @click="handleSelect()"
    >
      <span
        v-if="
          activityDetailsTicketsStore.isActivitySelected ||
          !activityDetailsTicketsStore.shouldScrollToTicket
        "
      >
        {{ $t('planner.update') }}
      </span>
      <span v-else>
        {{ $t('planner.select_ticket') }}
      </span>
    </AppButton>
  </footer>
</template>

<style lang="scss" scoped>
.activity-details-footer {
  padding: var(--spacing-24) var(--spacing-32);
  display: flex;
  justify-content: flex-end;
  z-index: 1;
  align-items: center;

  @include for-more-or-equal-than-1200-px {
    border-radius: 0 0 var(--border-radius-12) var(--border-radius-12);
  }

  .payment-summary {
    margin-right: var(--spacing-24);
    text-align: right;
    display: flex;

    .total-price {
      display: flex;
      flex-direction: column;
      justify-content: center;

      .total-price--header {
        color: var(--color-neutral-70);
        @include font-label-l-light;
      }

      .total-price--price {
        color: var(--color-neutral-70);
        @include font-label-xxl-bold;
      }
    }
  }

  @include for-less-or-equal-than-1200-px {
    display: flex;
    justify-content: space-between;
    align-items: center;
    .payment-summary {
      text-align: left;
    }
  }
  .select-activities-button {
    margin: var(--spacing-2) 0;
  }
}
</style>
